import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-remaining-time-admin-config',
  templateUrl: './remaining-time-admin-config.component.html',
  styleUrls: ['./remaining-time-admin-config.component.scss']
})
export class AtwRemainingTimeAdminConfig  extends AtwUpdateDbComponent  implements OnInit {

@Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  none: boolean = false; // có chọn PHONG CÁCH hay chưa (true=>chưa; false:đã chọn)

  unSelected: any;
  dataAfterChange: any  = {}
  id_subproject: any = "";

  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      img: '../../../../../assets/root/icon/user/gdDefault.png',
      deg: '180deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      img: '../../../../../assets/root/icon/user/gdToRight.png',
      deg: '90deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      img: '../../../../../assets/root/icon/user/gdToLeft.png',
      deg: '270deg'
    },
  ];
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void { 
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['text-name__content']['text-shadow']
    //   && !this.class['text-name']['background-color']
    //   && this.class['text-name__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }
  }
  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  ngOnDestroy() {
    this.saveDataProperties();
  }

  openBgColor() {
    document.getElementById('input-color').click();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }
  // Phần GRADIENT
  
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image'].gradient_check) {
      this.class['text-name__content']['background-image'] = `linear-gradient(${this.config['background-image']['gradient_direction']} ${this.config['background-image']['gradient_arr_gradient']})`;
      this.class['text-name__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text-name__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text-name__content']['background-image'] = 'none';
      this.class['text-name__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text-name__content']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['gradient_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['gradient_opacity'] / 100})`
    })
    this.config['background-image']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientText();
  }
  openbgGradient() {
    document.getElementById('input-gradient').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['gradient_background_color'])}, ${this.config['background-image']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  customize = []
  
  /**
    * Cập nhật link page
    * @param value 
    */
  updateLinkPage(value) {
    
    this.unSelected = value.link;
    if (this.unSelected != null && this.unSelected.length > 0) {
      this.updateCss('data', this.data_tool.data);
    }
    if (value.hyper_link != null && value.hyper_link.length > 0) {
      this.updateCss('data', this.data_tool.data);
    }
  }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config`
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name, key) {
    // lấy tên và giá trị style đã thay đổi.
    this.dataAfterChange[name] = { ...key }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };

  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb.updateObject(this.data_tool._id, this.dataAfterChange)
        .then((bool) => {
          
        }, error => {
          console.error(error)
        })
  }
    /**
   * Cập nhật staticdata vào database.
   */
    updateStaticData() {
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
        .then((bool) => {
        });
    }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
